import React from "react";
import "../../../ReactKaamvalaWebsite/Pages/Not-Found/NotFound.css";
import error from "../../../ReactKaamvalaWebsite/assets/image/Error.jpg";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="error_container d-flex flex-column align-items-center justify-content-center">
        <img src={error} alt="NotFound" />
        <h1>Page Not Found</h1>
        <div className="d-flex align-items-center gap-2 justify-content-center">
          <FaArrowLeftLong onClick={() => navigate("/")} />
          <span>Back</span>
        </div>
      </div>
    </>
  );
};
export default NotFound;
